export default __webpack_public_path__ + "f17670d159533888360fd1bc53c7b9d04fae8830e1dc42ea081797aca0f685fb.svg";